var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"DifficultyLabel",class:_vm.selected ? ("active color" + _vm.difficultyTitle) : ("color" + _vm.difficultyTitle),on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.difficultyTitle)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }